import { PendingPoints, VerificationPoints } from "models";

/**
 * This function sums up the points (pending and verification) of all passed field modules by category
 */
export const calculatePoints = (fieldModules: { pendingPoints: PendingPoints | null; verificationPoints: VerificationPoints | null }[] = []): PendingPoints =>
  fieldModules.reduce(
    (acc: PendingPoints, { pendingPoints, verificationPoints }) => {
      acc.minCategory1 += (pendingPoints?.minCategory1 || 0) + (verificationPoints?.category1 || 0);
      acc.maxCategory1 += (pendingPoints?.maxCategory1 || 0) + (verificationPoints?.category1 || 0);
      acc.minCategory2 += (pendingPoints?.minCategory2 || 0) + (verificationPoints?.category2 || 0);
      acc.maxCategory2 += (pendingPoints?.maxCategory2 || 0) + (verificationPoints?.category2 || 0);
      acc.minCategory3 += (pendingPoints?.minCategory3 || 0) + (verificationPoints?.category3 || 0);
      acc.maxCategory3 += (pendingPoints?.maxCategory3 || 0) + (verificationPoints?.category3 || 0);
      acc.minCategory4 += (pendingPoints?.minCategory4 || 0) + (verificationPoints?.category4 || 0);
      acc.maxCategory4 += (pendingPoints?.maxCategory4 || 0) + (verificationPoints?.category4 || 0);

      return acc;
    },
    {
      minCategory1: 0,
      maxCategory1: 0,
      minCategory2: 0,
      maxCategory2: 0,
      minCategory3: 0,
      maxCategory3: 0,
      minCategory4: 0,
      maxCategory4: 0,
    }
  );

export const calculateVerificationPointsSum = (points: VerificationPoints): number => {
  if (!points) {
    return 0;
  }

  return points.category1 + points.category2 + points.category3 + points.category4;
};

export const calculatePendingPointsSum = (points: PendingPoints): { min: number; max: number } => {
  if (!points) {
    return {
      min: 0,
      max: 0,
    };
  }

  return {
    min: points.minCategory1 + points.minCategory2 + points.minCategory3 + points.minCategory4,
    max: points.maxCategory1 + points.maxCategory2 + points.maxCategory3 + points.maxCategory4,
  };
};

export const hasPendingPoints = (fieldModules: { pendingPoints: PendingPoints | null }[] = []) =>
  fieldModules.some(({ pendingPoints }) => !!pendingPoints && Object.entries(pendingPoints).some(([key, value]) => key.includes("Category") && value !== null));
